<script setup lang="ts">
import { computed } from 'vue'

import Collapsible from './Collapsible.vue'

import type { UnifiedProduct } from '../../../composables/use-product-group'

const props = withDefaults(defineProps<{
  unifiedProducts?: UnifiedProduct[]
  isInAutocomparison?: boolean
}>(), {
  unifiedProducts: () => [],
  isInAutocomparison: false
})

const uniqueKeys = computed(() => {
  const keys = new Set<string>()
  props.unifiedProducts.forEach(product => {
    product.technicalData?.forEach(item => {
      if (item.key) {
        keys.add(item.key)
      }
    })
  })
  return Array.from(keys)
})

const getValue = (key: string, product: UnifiedProduct) => {
  const item = product.technicalData?.find(i => i.key === key)
  return item ? item.value : '-'
}
</script>

<template>
  <Collapsible content-id="technical-data"
               add-data-tc="product-technical-data"
               :control-style="isInAutocomparison ? 'large' : 'small'"
               :control-border="unifiedProducts[0].extendedInformationOrder.indexOf('technicalData') === 0 ? 'none' : 'top'"
               label="Technische Daten"
               add-class-content="bx-tech-data__table">
    <template #content>
      <template v-for="(row, rowIndex) in uniqueKeys"
                :key="rowIndex">
        <div :data-tc="`product-technical-data-${rowIndex}-key`">
          <span>{{ row }}</span>
        </div>
        <div>
          <div v-for="(product, productIndex) in unifiedProducts"
               :key="product.uniqueId"
               :data-product-unique-id="product.uniqueId"
               :data-tc="`product-technical-data-${rowIndex}-${productIndex}-value`">
            {{ getValue(row, product) }}
          </div>
        </div>
      </template>
    </template>
  </Collapsible>
</template>
